import { useState } from 'react';
import { useInRouterContext, useNavigate } from 'react-router-dom';
// @ts-ignore — CSS module sin tipos
import styles from './NudgeCard.module.css';
import ModalAcceptCancel from '@Molecules/ModalAcceptCancel/ModalAcceptCancel';
import { useNudge } from '../../hooks/useNudge';

const NudgeCardInner = () => {
  const navigate = useNavigate();
  const { nudge, visible, busy, accept, postpone, never } = useNudge(navigate);
  const [confirming, setConfirming] = useState(false);

  if (!visible || !nudge) return null;

  return (
    <>
      <div className={styles.card} role="status" data-testid="adri-nudge">
        <div className={styles.text}>{nudge.text}</div>
        <div className={styles.actions}>
          <button type="button" className={styles.primary} onClick={accept} disabled={busy} data-testid="adri-nudge-guide">
            Sí, guíame
          </button>
          <button type="button" className={styles.secondary} onClick={postpone} disabled={busy} data-testid="adri-nudge-later">
            Ahora no
          </button>
        </div>
        <button type="button" className={styles.link} onClick={() => setConfirming(true)} data-testid="adri-nudge-never">
          No me lo recuerdes
        </button>
      </div>
      {confirming && (
        <ModalAcceptCancel
          showButtons={{ showButtonClose: false, showButtonOne: true, showButtonTwo: true }}
          buttonOne={{
            textButtonOne: 'Sí, no recordarme',
            actionButtonOne: () => {
              setConfirming(false);
              never();
            },
          }}
          buttonTwo={{ textButtonTwo: 'Cancelar', actionButtonTwo: () => setConfirming(false) }}
        >
          <div>
            <h3>No te recordaré más</h3>
            <p>Adri dejará de sugerirte pasos. Podrás seguir abriendo el chat cuando quieras.</p>
          </div>
        </ModalAcceptCancel>
      )}
    </>
  );
};

/** 051 — Empujón anclado bajo AdriHeaderButton (PRD §7.3). */
const NudgeCard = () => (useInRouterContext() ? <NudgeCardInner /> : null);

export default NudgeCard;
